export default __webpack_public_path__ + "assets/3ab91faf3bda93155f4a7e8e6a8f0f3d.svg";